import { createSlice } from "@reduxjs/toolkit";
import { logoutUser } from "../../utils/session";

interface AuthState {
  user: any;
  token: string | null;
  isAuthenticated: boolean;
}

const savedToken = sessionStorage.getItem("token");
const savedUser = sessionStorage.getItem("user");

const initialState: AuthState = {
  user: savedUser ? savedUser : null,
  token: savedToken || null,
  isAuthenticated: !!savedToken,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess(state, action) {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.isAuthenticated = true;
    },

    logout(state) {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      logoutUser();
    },
  },
});

export const { loginSuccess, logout } = authSlice.actions;
export default authSlice.reducer;
